import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { BookOpenText, BrainCircuit } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import AgentTrainingManagement from "../TrainingManagement";
import AgentAssessmentManagement from "../AgentAssessmentManagement";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const AgentTrainingTabs = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={BookOpenText} label="Manage Trainings" />
          <CustomTab icon={BrainCircuit} label="Certificate Assessments" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <AgentTrainingManagement/>
          </TabPanel>
           <TabPanel>
            <AgentAssessmentManagement/>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default AgentTrainingTabs;
